import { cliente } from "../http/cliente";
import type {
  ComposicaoOut,
  EmpresaProjetavelOut,
  ProjecaoEmpresaOut,
  ProjecaoGrupoOut,
} from "./tipos";

/*
 * Fetchers da projeção (FE-2 CP-A — ADR 0026).
 *
 * Camada fina sobre o `cliente` HTTP (CP-C): injeta Bearer, trata refresh/401/503
 * e normaliza erro em `ErroHttp`. Estes fetchers NÃO tratam erro — propagam a
 * rejeição do `cliente` para o TanStack Query (hooks em `./hooks`) decidir.
 *
 * `baseURL` do cliente já é `/api`, então os paths aqui são relativos a ela.
 * `horizonte` vai como query param (o backend valida 1..365 e aplica o default).
 */

/** `GET /api/empresas/{empresa_id}/projecao?horizonte=N`. */
export async function buscarProjecaoEmpresa(
  empresaId: string,
  horizonte: number,
): Promise<ProjecaoEmpresaOut> {
  const resposta = await cliente.get<ProjecaoEmpresaOut>(
    `/empresas/${empresaId}/projecao`,
    { params: { horizonte } },
  );
  return resposta.data;
}

/** `GET /api/grupo/projecao?horizonte=N`. */
export async function buscarProjecaoGrupo(
  horizonte: number,
): Promise<ProjecaoGrupoOut> {
  const resposta = await cliente.get<ProjecaoGrupoOut>("/grupo/projecao", {
    params: { horizonte },
  });
  return resposta.data;
}

/** `GET /api/projecao/empresas` — empresas projetáveis pelo escopo do usuário. */
export async function buscarEmpresasProjetaveis(): Promise<
  EmpresaProjetavelOut[]
> {
  const resposta =
    await cliente.get<EmpresaProjetavelOut[]>("/projecao/empresas");
  return resposta.data;
}

/**
 * `GET /api/empresas/{empresa_id}/projecao/composicao?data=YYYY-MM-DD&horizonte=N`
 * — composição itemizada de um dia (drill-down da tela 2 — BE gap A).
 *
 * `data`/`horizonte` vão como query params; o backend valida `data` ∈ [hoje,
 * hoje+horizonte]. NÃO trata erro (propaga ao TanStack Query como os demais).
 */
export async function buscarComposicao(
  empresaId: string,
  data: string,
  horizonte: number,
): Promise<ComposicaoOut> {
  const resposta = await cliente.get<ComposicaoOut>(
    `/empresas/${empresaId}/projecao/composicao`,
    { params: { data, horizonte } },
  );
  return resposta.data;
}
